import { render, staticRenderFns } from "./VentaAmigoAbonadoComponent.vue?vue&type=template&id=6a841048"
import script from "./VentaAmigoAbonadoComponent.vue?vue&type=script&lang=js"
export * from "./VentaAmigoAbonadoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports